import { render, staticRenderFns } from "./StatsDailyQuestion.vue?vue&type=template&id=cb638dfc&"
import script from "./StatsDailyQuestion.vue?vue&type=script&lang=js&"
export * from "./StatsDailyQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports